import { api } from '~/redux/api/createApi';
import { useRouting } from '~/routing/useRouting';

import { ConfigurationDetailPanel } from './ConfigurationDetailPanel/ConfigurationDetailPanel';
import { SyncPairConfig } from './ConfigurationDetailPanel/types';

interface Props {
  config: SyncPairConfig;
  tab: 'config' | 'errors';
  onHide: () => void;
}

export const StorageConfigurationPanel = (configPanelProps: Props) => {
  const { params } = useRouting();
  const { clientId } = params;
  const { config } = configPanelProps;
  const {
    data: errors = {
      results: [],
      count: 0,
    },
    isLoading,
    isError,
  } = api.endpoints.getFileLevelEvents.useQuery(
    {
      syncPair: config.id,
      clientId: Number(clientId),
    },
    {
      skip: !config.id || !clientId,
    },
  );

  return (
    <ConfigurationDetailPanel
      {...configPanelProps}
      errors={errors}
      isError={isError}
      isLoading={isLoading}
    />
  );
};
